import { formatError } from './errors/formatError.js';
import 'whatwg-fetch';
import { NetworkProfiling } from './networkProfiling.js';
import { formatAISError } from './errors/formatAISError.js';
import './tslib.es6-b2cb7a63.js';
import './errors/errorCodes.js';
import './errors/appError.js';
import './eventEmitter.js';
import 'lodash';
import './device.js';
import 'ua-parser-js';
import './errors/AISErrorCodes.js';

function doFetch(url, options) {
    var response;
    var origResp;
    var hasQuery = url.indexOf('?') !== -1;
    if ((options === null || options === void 0 ? void 0 : options.query) && typeof options.query === 'object') {
        for (var key in options.query) {
            url += "" + (hasQuery ? '&' : '?') + encodeURIComponent(key) + "=" + encodeURIComponent(options.query[key]);
            hasQuery = true;
        }
    }
    return fetch(url, options)
        .then(function (res) {
        if (NetworkProfiling.isInstantiate()) {
            origResp = res.clone();
        }
        response = res;
        if (options === null || options === void 0 ? void 0 : options.rawResponse) {
            return response;
        }
        // if (!res.ok) {
        //   throw new Error(`[${response.status}] ${response.statusText}`);
        // }
        if (options === null || options === void 0 ? void 0 : options.type) {
            switch (options.type) {
                case 'arrayBuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'formData':
                    return response.formData();
                case 'json':
                    return response.json();
                case 'text':
                default:
                    return response.text();
            }
        }
        return response.json();
    })
        .catch(function (error) {
        if ((options === null || options === void 0 ? void 0 : options.errorFormatter) === 'AIS') {
            throw formatAISError(error, response || {});
        }
        else {
            throw formatError(error, true, response || {});
        }
    }).finally(function () {
        if (NetworkProfiling.isInstantiate() && origResp) {
            NetworkProfiling.instance().handleResponse(origResp);
        }
    });
}

export { doFetch };
